import React, { useState, useEffect, useRef } from 'react';
import { ref, get, push, set, runTransaction } from 'firebase/database'; // ← aggiunto runTransaction
import { database } from '../../firebase/config';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { pdf } from '@react-pdf/renderer';
import SignatureCanvas from 'react-signature-canvas';
import { uploadImmagine } from '../../utils/cloudinaryUtils';

// ─── STILI PDF ────────────────────────────────────────────────────────────────
const pdfStyles = StyleSheet.create({
  page:        { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  title:       { fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginBottom: 16 },
  section:     { marginBottom: 10 },
  row:         { flexDirection: 'row', marginBottom: 4 },
  label:       { fontWeight: 'bold', width: 160 },
  value:       { flex: 1 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#e0e0e0', padding: 4, marginBottom: 2, fontWeight: 'bold' },
  tableRow:    { flexDirection: 'row', padding: 4, borderBottom: '1 solid #ccc' },
  col1:        { width: '40%' },
  col2:        { width: '30%' },
  col3:        { width: '30%' },
  divider:     { borderBottom: '1 solid #aaa', marginVertical: 8 },
  firmaBox:    { marginTop: 8 },
  firmaImg:    { width: 200, height: 80, border: '1 solid #999' },
  firmaTestuale: { marginTop: 6, fontSize: 10, color: '#333' },
  footerRow:   { flexDirection: 'row', justifyContent: 'space-between', marginTop: 16 },
  footerCol:   { width: '45%' },
  footerLabel: { fontWeight: 'bold', marginBottom: 4 },
  prestazione: { marginTop: 4, lineHeight: 1.5 },
  // Intestazione con logo e recapiti
  intestazione:     { flexDirection: 'row', alignItems: 'center', marginBottom: 16, paddingBottom: 10, borderBottom: '1 solid #ccc' },
  logoImg:          { width: 80, height: 32, objectFit: 'contain' },
  recapiti:         { marginLeft: 12, fontSize: 9, color: '#333' },
  recapitiNome:     { fontSize: 10, fontWeight: 'bold', marginBottom: 2 },
  // ── NUOVO: box numero bolla ──────────────────────────────────────────────
  numeroBollaBox:   { marginLeft: 'auto', backgroundColor: '#1a1a1a', borderRadius: 4, paddingVertical: 6, paddingHorizontal: 12, alignItems: 'center', justifyContent: 'center' },
  numeroBollaLabel: { fontSize: 7, color: '#aaa', textTransform: 'uppercase', letterSpacing: 1 },
  numeroBollaText:  { fontSize: 20, fontWeight: 'bold', color: '#ffffff' },
  // ────────────────────────────────────────────────────────────────────────
  // Pagina 2 – foto pesata
  page2:              { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
  page2Title:         { fontSize: 14, fontWeight: 'bold', textAlign: 'center', marginBottom: 12 },
  page2Subtitle:      { fontSize: 10, color: '#555', textAlign: 'center', marginBottom: 16 },
  fotoPesataImg:      { width: '100%', maxHeight: 620, objectFit: 'contain', border: '1 solid #ccc' },
  fotoPesataBox:      { width: '100%', height: 300, border: '1 solid #ccc', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f5f5f5' },
  fotoPesataNone:     { color: '#999', fontSize: 12 },
});

// ─── COMPONENTE PDF ───────────────────────────────────────────────────────────
function fmtData(d) {
  if (!d) return '';
  const parts = d.split('-');
  if (parts.length !== 3) return d;
  return `${parts[2]}-${parts[1]}-${parts[0]}`;
}

function BollaPDF({ dati }) {
  const {
    cliente, cantiere, data, mezzi,
    smaltimentoScavo, smaltimentoDemo,
    fornituraMistoGranulare, fornituraGhiaia, smaltimentoAsfalto,
    prestazione, nomeAutista,
    firmaBase64, fotoPesataUrl,
    nomeClienteFirma,
    numeroBolla,  // ← NUOVO
  } = dati;

  return (
    <Document>
      {/* ── PAGINA 1 – Contenuto bolla ── */}
      <Page size="A4" style={pdfStyles.page}>
        {/* Intestazione: logo + recapiti ditta + NUMERO BOLLA */}
        <View style={pdfStyles.intestazione}>
          <Image src="CRG_logo.png" style={pdfStyles.logoImg} />
          <View style={pdfStyles.recapiti}>
            <Text style={pdfStyles.recapitiNome}>C.R.G. Scavi e trasporti Sagl</Text>
            <Text>Via Livio 5, 6830 Chiasso (TI)</Text>
            <Text>Tel: +41 78 751 32 51 - email:info@crgscavi.ch</Text>
          </View>
          {/* ── NUOVO: numero bolla ben visibile ── */}
          <View style={pdfStyles.numeroBollaBox}>
            <Text style={pdfStyles.numeroBollaLabel}>N° BOLLA</Text>
            <Text style={pdfStyles.numeroBollaText}>{numeroBolla}</Text>
          </View>
        </View>

        <Text style={pdfStyles.title}>BOLLA DI LAVORO</Text>

        <View style={pdfStyles.section}>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Cliente</Text>
            <Text style={pdfStyles.value}>{cliente}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Cantiere</Text>
            <Text style={pdfStyles.value}>{cantiere}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Data</Text>
            <Text style={pdfStyles.value}>{fmtData(data)}</Text>
          </View>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Mezzi utilizzati</Text>
          <View style={pdfStyles.tableHeader}>
            <Text style={pdfStyles.col1}>Mezzo</Text>
            <Text style={pdfStyles.col2}>Ore</Text>
            <Text style={pdfStyles.col3}>KM</Text>
          </View>
          {mezzi.filter(m => m.veicoloId).map((m, i) => (
            <View key={i} style={pdfStyles.tableRow}>
              <Text style={pdfStyles.col1}>{m.label}</Text>
              <Text style={pdfStyles.col2}>{m.ore || '-'}</Text>
              <Text style={pdfStyles.col3}>{m.km || '-'}</Text>
            </View>
          ))}
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Smaltimento materiale da scavo (m³)</Text>
            <Text style={pdfStyles.value}>{smaltimentoScavo || '-'}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Smaltimento demolizione (m³)</Text>
            <Text style={pdfStyles.value}>{smaltimentoDemo || '-'}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Fornitura misto granulare 0.45 (m³)</Text>
            <Text style={pdfStyles.value}>{fornituraMistoGranulare || '-'}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Fornitura ghiaia (m³)</Text>
            <Text style={pdfStyles.value}>{fornituraGhiaia || '-'}</Text>
          </View>
          <View style={pdfStyles.row}>
            <Text style={pdfStyles.label}>Smaltimento asfalto (m³)</Text>
            <Text style={pdfStyles.value}>{smaltimentoAsfalto || '-'}</Text>
          </View>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.section}>
          <Text style={{ fontWeight: 'bold', marginBottom: 4 }}>Prestazione</Text>
          <Text style={pdfStyles.prestazione}>{prestazione || '-'}</Text>
        </View>

        <View style={pdfStyles.divider} />

        <View style={pdfStyles.footerRow}>
          <View style={pdfStyles.footerCol}>
            <Text style={pdfStyles.footerLabel}>Nome autista</Text>
            <Text>{nomeAutista}</Text>
          </View>
          <View style={pdfStyles.footerCol}>
            <Text style={pdfStyles.footerLabel}>Firma cliente</Text>
            {firmaBase64
              ? <Image src={firmaBase64} style={pdfStyles.firmaImg} />
              : <Text style={{ color: '#999' }}>Non firmato</Text>
            }
            {nomeClienteFirma ? (
              <Text style={{ marginTop: 4, fontSize: 10 }}>{nomeClienteFirma}</Text>
            ) : null}
          </View>
        </View>

      </Page>

      {/* ── PAGINA 2 – Foto pesata (SEMPRE presente) ── */}
      <Page size="A4" style={pdfStyles.page2}>
        <Text style={pdfStyles.page2Title}>FOTO PESATA</Text>
        <Text style={pdfStyles.page2Subtitle}>{cantiere} — {fmtData(data)}</Text>
        <View style={pdfStyles.divider} />

        {fotoPesataUrl
          ? <Image src={fotoPesataUrl} style={pdfStyles.fotoPesataImg} />
          : (
            <View style={pdfStyles.fotoPesataBox}>
              <Text style={pdfStyles.fotoPesataNone}>Nessuna foto pesata allegata</Text>
            </View>
          )
        }
      </Page>
    </Document>
  );
}

// ─── FUNZIONE NUMERO BOLLA ────────────────────────────────────────────────────
// Usa runTransaction per garantire atomicità.
// Se due bolle vengono create nello stesso millisecondo, la seconda riceve suffisso 'b'.
async function ottieniNumeroBolla() {
  const contRef = ref(database, 'bolle_contatore');
  const now = Date.now();

  let numeroAssegnato = null;

  await runTransaction(contRef, (datiCorrente) => {
    if (datiCorrente === null) {
      // Prima bolla in assoluto
      numeroAssegnato = '1';
      return { valore: 1, timestamp: now };
    }

    const nuovoValore = (datiCorrente.valore || 0) + 1;

    // Collisione: stessa bolla creata nello stesso millisecondo esatto
    if (datiCorrente.timestamp === now) {
      // Stessa transazione rapida: aggiungi suffisso 'b' alla precedente e 'b' a questa
      // In realtà la transazione garantisce serializzazione, ma per sicurezza extra:
      numeroAssegnato = `${nuovoValore}b`;
    } else {
      numeroAssegnato = `${nuovoValore}`;
    }

    return { valore: nuovoValore, timestamp: now };
  });

  return numeroAssegnato;
}

// ─── FORM PRINCIPALE ──────────────────────────────────────────────────────────
function CreaBollaForm({ dipendente, onBack, onBollaSalvata }) {
  const oggi = new Date().toISOString().split('T')[0];

  const [cantieri, setCantieri]               = useState([]);
  const [clienti, setClienti]                 = useState([]);
  const [veicoli, setVeicoli]                 = useState([]);
  const [clienteId, setClienteId]             = useState('');
  const [cantiereId, setCantiereId]           = useState('');
  const [data, setData]                       = useState(oggi);

  const mezziVuoti = [
    { veicoloId: '', ore: '', km: '' },
    { veicoloId: '', ore: '', km: '' },
    { veicoloId: '', ore: '', km: '' },
  ];
  const [mezzi, setMezzi]                     = useState(mezziVuoti);
  const [smaltimentoScavo, setSmaltimentoScavo] = useState('');
  const [smaltimentoDemo, setSmaltimentoDemo]   = useState('');
  const [fornituraMistoGranulare, setFornituraMistoGranulare] = useState('');
  const [fornituraGhiaia, setFornituraGhiaia]     = useState('');
  const [smaltimentoAsfalto, setSmaltimentoAsfalto] = useState('');

  const [fotoPesataFile, setFotoPesataFile]   = useState(null);
  const [fotoPesataPreview, setFotoPesataPreview] = useState(null);
  const [uploadingFoto, setUploadingFoto]     = useState(false);

  const [prestazione, setPrestazione]         = useState('');
  const [showFirma, setShowFirma]             = useState(false);
  const [firmaBase64, setFirmaBase64]         = useState(null);
  const [nomeClienteFirma, setNomeClienteFirma] = useState('');
  const [saving, setSaving]                   = useState(false);
  const sigRef = useRef(null);

  // ── carica dati da Firebase ──
  useEffect(() => {
    async function carica() {
      const [cantSnap, cliSnap, veiSnap] = await Promise.all([
        get(ref(database, 'cantieri')),
        get(ref(database, 'clienti')),
        get(ref(database, 'veicoli')),
      ]);
      if (cantSnap.exists()) setCantieri(Object.entries(cantSnap.val()).map(([k, v]) => ({ id: k, ...v })));
      if (cliSnap.exists())  setClienti(Object.entries(cliSnap.val()).map(([k, v]) => ({ id: k, ...v })));
      if (veiSnap.exists())  setVeicoli(Object.entries(veiSnap.val()).map(([k, v]) => ({ id: k, ...v })));
    }
    carica();
  }, []);

  const cantieriFiltrati = clienteId
    ? cantieri.filter(c => c.clienteId === clienteId)
    : cantieri;

  function updateMezzo(index, field, value) {
    setMezzi(prev => {
      const copia = [...prev];
      copia[index] = { ...copia[index], [field]: value };
      return copia;
    });
  }

  function getLabelVeicolo(v) { return `${v.marca} ${v.modello} - ${v.targa}`; }

  function formatDataNome(d) {
    const [anno, mese, giorno] = d.split('-');
    return `${giorno}${mese}${anno.slice(2)}`;
  }

  function handleFotoPesataChange(e) {
    const file = e.target.files[0];
    if (!file) return;
    setFotoPesataFile(file);
    setFotoPesataPreview(URL.createObjectURL(file));
  }

  function rimuoviFotoPesata() {
    setFotoPesataFile(null);
    setFotoPesataPreview(null);
  }

  function confermaFirma() {
    if (sigRef.current && !sigRef.current.isEmpty()) {
      setFirmaBase64(sigRef.current.toDataURL('image/png'));
      setShowFirma(false);
    }
  }

  function cancellaPad() { sigRef.current?.clear(); }


function dataURLToFile(dataUrl, filename) {
  if (!dataUrl || typeof dataUrl !== 'string') {
    throw new Error('FIRMA_DATAURL_ASSENTE');
  }

  const parts = dataUrl.split(',');
  if (parts.length !== 2) {
    throw new Error('FIRMA_FORMATO_NON_VALIDO');
  }

  const mimeMatch = parts[0].match(/data:(.*?);base64/);
  const mime = mimeMatch ? mimeMatch[1] : 'image/png';
  const binary = atob(parts[1]);
  const len = binary.length;
  const bytes = new Uint8Array(len);

  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }

  return new File([bytes], filename, { type: mime });
}


  // ── salva ──
  async function handleSalva() {
    if (!clienteId) return alert('Seleziona un cliente');
    if (!cantiereId) return alert('Seleziona un cantiere');

    const clienteObj  = clienti.find(c => c.id === clienteId);
    const cantiereObj = cantieri.find(c => c.id === cantiereId);
    const nomeAutista = dipendente ? `${dipendente.nome} ${dipendente.cognome}` : '';
    const mezziConLabel = mezzi.map(m => ({
      ...m,
      label: m.veicoloId
        ? getLabelVeicolo(veicoli.find(v => v.id === m.veicoloId))
        : '',
    }));

    try {
      setSaving(true);

      // ── NUOVO: ottieni numero bolla atomico ──────────────────────────────
      const numeroBolla = await ottieniNumeroBolla();

      // 0. Upload firma su Cloudinary (se presente)
      
      let firmaUrl = null;
      let firmaPubblicId = null;
      let firmaUploadWarning = null;

      if (firmaBase64) {
        let uploadStep = 'INIT';

        try {
          uploadStep = 'FIRMA_BASE64_TO_FILE';
          const firmaFile = dataURLToFile(firmaBase64, `firma-${Date.now()}.png`);

          uploadStep = 'FIRMA_UPLOAD_CLOUDINARY';
          const { imageUrl, publicId } = await uploadImmagine(firmaFile, 'firme');

          firmaUrl = imageUrl;
          firmaPubblicId = publicId;
        } catch (uploadErr) {
          const isStandalone =
            window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true;

          const connectionType =
            navigator.connection?.effectiveType ||
            navigator.connection?.type ||
            'n/d';

          try {
            const nomeDipendenteLog = dipendente
              ? `${dipendente.nome} ${dipendente.cognome}`
              : 'Sconosciuto';
            const now = new Date();

            const logRecord = {
              data: now.toISOString().slice(0, 10),
              ora: now.toTimeString().slice(0, 8),
              dipendenteId: dipendente?.id || null,
              dipendente: nomeDipendenteLog,
              tipo: 'Bolla',
              errore: uploadErr.code || uploadErr.name || 'FIRMA_UPLOAD_WARNING',
              dettaglio: `${uploadStep ? `[${uploadStep}] ` : ''}${uploadErr.message || 'Errore upload firma'}`,
              severity: 'warning',
              appVersion: process.env.REACT_APP_VERSION || 'n/d',
              userAgent: navigator.userAgent || 'n/d',
              platform: navigator.platform || 'n/d',
              lingua: navigator.language || 'n/d',
              online: typeof navigator.onLine === 'boolean' ? navigator.onLine : 'n/d',
              isStandalone,
              connectionType,
              firmaUploadFailed: true,
              createdAt: Date.now(),
            };

            const logRef = push(ref(database, 'error_logs'));
            await set(logRef, logRecord);
          } catch (logErr) {
            console.warn('Log warning firma fallito:', logErr.message);
          }

          firmaUploadWarning = uploadErr.message || 'Upload firma non riuscito';
          firmaUrl = null;
          firmaPubblicId = null;
        }
      }

      // 1. Upload foto pesata su Cloudinary (se presente)
      let fotoPesataUrl = null;
      let fotoPesataPubblicId = null;
      let uploadStep = 'INIT';

      if (fotoPesataFile) {
        try {
          uploadStep = 'FOTO_PESATA_UPLOAD_CLOUDINARY';
          setUploadingFoto(true);

          const { imageUrl, publicId } = await uploadImmagine(fotoPesataFile, 'pesate');

          fotoPesataUrl = imageUrl;
          fotoPesataPubblicId = publicId;
          uploadStep = 'FOTO_PESATA_UPLOAD_OK';
        } catch (uploadErr) {
          uploadErr.uploadStep = uploadStep;
          throw uploadErr;
        } finally {
          setUploadingFoto(false);
        }
      }

      // 2. Dati per il PDF
      const datiPDF = {
        cliente: clienteObj?.ragioneSociale || clienteId,
        cantiere: cantiereObj?.luogo || cantiereId,
        data,
        mezzi: mezziConLabel,
        smaltimentoScavo,
        smaltimentoDemo,
        fornituraMistoGranulare,
        fornituraGhiaia,
        smaltimentoAsfalto,
        prestazione,
        nomeAutista,
        firmaBase64: firmaUrl,
        nomeClienteFirma,
        fotoPesataUrl,
        numeroBolla,
      };

      // 3. Genera PDF come blob
      const blob = await pdf(<BollaPDF dati={datiPDF} />).toBlob();

      // 4. Nome file ggmmaa-cantiere-dipendente.pdf
      const nomeCantiere = (cantiereObj?.luogo || 'cantiere').replace(/\s+/g, '_').toLowerCase();
      const nomeDip = nomeAutista.replace(/\s+/g, '_').toLowerCase();
      const nomeFile = `${formatDataNome(data)}_${nomeCantiere}_${nomeDip}.pdf`;

      // 5. Scarica il PDF nel browser
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = nomeFile;
      a.click();
      URL.revokeObjectURL(url);

      // 6. Salva record su Firebase
      const bollaRecord = {
        dipendenteId: dipendente?.id,
        clienteId,
        cantiereId,
        data,
        mezzi: mezziConLabel,
        smaltimentoScavo,
        smaltimentoDemo,
        fornituraMistoGranulare,
        fornituraGhiaia,
        smaltimentoAsfalto,
        prestazione,
        nomeAutista,
        firmaUrl,
        nomeClienteFirma: nomeClienteFirma || '',
        firmaPubblicId,
        fotoPesataUrl,
        fotoPesataPubblicId,
        nomeFile,
        numeroBolla,
        createdAt: Date.now(),
      };

      const newRef = push(ref(database, 'bolleForm'));
      await set(newRef, bollaRecord);

      if (firmaUploadWarning) {
        alert(
          'Bolla salvata e PDF scaricato.\n\nAttenzione: la firma non è stata caricata.\nDettaglio: ' +
          firmaUploadWarning
        );
      } else {
        alert('Bolla salvata e PDF scaricato!');
      }

      if (onBollaSalvata) onBollaSalvata();
      onBack();
    } catch (err) {

      // ── LOG ERRORE AUTOMATICO ──────────────────────────
      try {
        const nomeDipendente = dipendente
          ? `${dipendente.nome} ${dipendente.cognome}`
          : 'Sconosciuto';
        const now = new Date();

        const isStandalone =
          window.matchMedia('(display-mode: standalone)').matches ||
          window.navigator.standalone === true;

        const connectionType =
          navigator.connection?.effectiveType ||
          navigator.connection?.type ||
          'n/d';

        const logRecord = {
          data: now.toISOString().slice(0, 10),
          ora: now.toTimeString().slice(0, 8),
          dipendenteId: dipendente?.id || null,
          dipendente: nomeDipendente,
          tipo: 'Bolla',          errore: err.code || err.name || 'ERRORE_GENERICO',
          dettaglio: `${err.uploadStep ? `[${err.uploadStep}] ` : ''}${err.message || 'Errore sconosciuto'}`,
          severity: 'critical',
          appVersion: process.env.REACT_APP_VERSION || 'n/d',
          userAgent: navigator.userAgent || 'n/d',
          platform: navigator.platform || 'n/d',
          lingua: navigator.language || 'n/d',
          online: typeof navigator.onLine === 'boolean' ? navigator.onLine : 'n/d',
          isStandalone,
          connectionType,
          createdAt: Date.now(),
        };

        const logRef = push(ref(database, 'error_logs'));
        await set(logRef, logRecord);
      } catch (logErr) {
        console.warn('Log errore fallito:', logErr.message);
      }
      // ───────────────────────────────────────────────────
      alert('Errore durante il salvataggio. Il problema è stato registrato automaticamente.\n\nDettaglio: ' + err.message);
    } finally {
      setSaving(false);
      setUploadingFoto(false);
    }
  }

  // ─── RENDER ────────────────────────────────────────────────────────────────
  return (
    <div className="dashboard-container">
      <div className="sidebar">
        <h2><img src="CRG_logo.png" alt="crg" style={{ width: 150 }} /></h2>
        <div className="user-info">
          <p>{dipendente ? `${dipendente.nome} ${dipendente.cognome}` : ''}</p>
        </div>
        <button className="btn-logout" onClick={onBack}>Torna indietro</button>
      </div>

      <div className="form-bolla">

        {/* CLIENTE */}
        <div className="form-group">
          <label>Cliente</label>
          <select value={clienteId} onChange={e => { setClienteId(e.target.value); setCantiereId(''); }}>
            <option value="">Seleziona cliente</option>
            {clienti.map(c => <option key={c.id} value={c.id}>{c.ragioneSociale}</option>)}
          </select>
        </div>

        {/* CANTIERE */}
        <div className="form-group">
          <label>Cantiere</label>
          <select value={cantiereId} onChange={e => setCantiereId(e.target.value)}>
            <option value="">Seleziona cantiere</option>
            {cantieriFiltrati.map(c => <option key={c.id} value={c.id}>{c.luogo}</option>)}
          </select>
        </div>

        {/* DATA */}
        <div className="form-group">
          <label>Data</label>
          <input type="date" value={data} onChange={e => setData(e.target.value)} />
        </div>

        {/* MEZZI */}
        <div className="form-group">
          <label>Mezzi utilizzati</label>
          <div className="mezzi-header">
            <span>Mezzo</span><span>Ore</span><span>KM</span>
          </div>
          {mezzi.map((m, i) => (
            <div className="mezzi-row" key={i}>
              <select value={m.veicoloId} onChange={e => updateMezzo(i, 'veicoloId', e.target.value)}>
                <option value="">Mezzo {i + 1}</option>
                {veicoli.map(v => <option key={v.id} value={v.id}>{getLabelVeicolo(v)}</option>)}
              </select>
              <input
                type="number" placeholder="Ore" value={m.ore}
                onChange={e => updateMezzo(i, 'ore', e.target.value)}
                disabled={!m.veicoloId}
              />
              <input
                type="number" placeholder="KM" value={m.km}
                onChange={e => updateMezzo(i, 'km', e.target.value)}
                disabled={!m.veicoloId}
              />
            </div>
          ))}
        </div>

        {/* SMALTIMENTO SCAVO */}
        <div className="form-group">
          <label>Smaltimento materiale da scavo (m³)</label>
          <input
            type="number" placeholder="0"
            value={smaltimentoScavo}
            onChange={e => setSmaltimentoScavo(e.target.value)}
          />
        </div>

        {/* SMALTIMENTO DEMOLIZIONE */}
        <div className="form-group">
          <label>Smaltimento demolizione (m³)</label>
          <input
            type="number" placeholder="0"
            value={smaltimentoDemo}
            onChange={e => setSmaltimentoDemo(e.target.value)}
          />
        </div>

        {/* FORNITURA MISTO GRANULARE */}
        <div className="form-group">
          <label>Fornitura misto granulare 0.45 (m³)</label>
          <input
            type="number" placeholder="0"
            value={fornituraMistoGranulare}
            onChange={e => setFornituraMistoGranulare(e.target.value)}
          />
        </div>

        {/* FORNITURA GHIAIA */}
        <div className="form-group">
          <label>Fornitura ghiaia (m³)</label>
          <input
            type="number" placeholder="0"
            value={fornituraGhiaia}
            onChange={e => setFornituraGhiaia(e.target.value)}
          />
        </div>

        {/* SMALTIMENTO ASFALTO */}
        <div className="form-group">
          <label>Smaltimento asfalto (m³)</label>
          <input
            type="number" placeholder="0"
            value={smaltimentoAsfalto}
            onChange={e => setSmaltimentoAsfalto(e.target.value)}
          />
        </div>

        {/* FOTO PESATA */}
        <div className="form-group">
          <label>Foto pesata</label>

          {!fotoPesataPreview ? (
            <label
              htmlFor="foto-pesata-input"
              style={{
                display: 'flex', alignItems: 'center', gap: 8,
                padding: '10px 16px', border: '2px dashed #bbb',
                borderRadius: 8, cursor: 'pointer', color: '#555',
                backgroundColor: '#fafafa', width: 'fit-content',
              }}
            >
              📷 Carica foto pesata
              <input
                id="foto-pesata-input"
                type="file"
                accept="image/*"
                capture="environment"
                style={{ display: 'none' }}
                onChange={handleFotoPesataChange}
              />
            </label>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8, alignItems: 'flex-start' }}>
              <img
                src={fotoPesataPreview}
                alt="Anteprima foto pesata"
                style={{
                  maxWidth: '100%', maxHeight: 200,
                  borderRadius: 8, border: '1px solid #ccc',
                  objectFit: 'contain',
                }}
              />
              <button
                className="btn-secondary small"
                onClick={rimuoviFotoPesata}
                style={{ marginTop: 4 }}
              >
                ✕ Rimuovi foto
              </button>
            </div>
          )}
        </div>

        {/* PRESTAZIONE */}
        <div className="form-group">
          <label>Prestazione</label>
          <textarea
            rows={5}
            placeholder="Descrivi le prestazioni eseguite..."
            value={prestazione}
            onChange={e => setPrestazione(e.target.value)}
          />
        </div>

        {/* AUTISTA + FIRMA */}
        <div className="firma-row">
          <div className="firma-col">
            <label>Nome autista</label>
            <p className="autista-name">
              {dipendente ? `${dipendente.nome} ${dipendente.cognome}` : ''}
            </p>
          </div>
          <div className="firma-col">
            <label>Firma cliente</label>
            {firmaBase64 ? (
              <div>
                <img src={firmaBase64} alt="Firma cliente" className="firma-preview" />
                <button className="btn-secondary small" onClick={() => setFirmaBase64(null)}>
                  Cancella firma
                </button>
              </div>
            ) : (
              <button className="btn-secondary" onClick={() => setShowFirma(true)}>
                Aggiungi firma
              </button>
            )}
          </div>
        </div>

        {/* Nome testuale cliente – opzionale */}
        <div className="form-group">
          <label>Nome e Cognome cliente (opzionale)</label>
          <input
            type="text"
            value={nomeClienteFirma}
            onChange={e => setNomeClienteFirma(e.target.value)}
            placeholder="Es. Mario Rossi"
          />
        </div>

        {/* BOTTONE SALVA */}
        <button
          className="btn-primary full-width"
          onClick={handleSalva}
          disabled={saving || uploadingFoto}
        >
          {saving
            ? uploadingFoto
              ? 'Caricamento foto pesata...'
              : 'Generazione PDF...'
            : 'Genera PDF e Salva'
          }
        </button>

      </div>

      {/* MODAL FIRMA */}
      {showFirma && (
        <div className="firma-overlay">
          <div className="firma-modal">
            <h3>Firma del cliente</h3>
            <p>Fai firmare il cliente con il dito</p>
            <div className="firma-canvas-wrapper">
              <SignatureCanvas
                ref={sigRef}
                canvasProps={{ className: 'firma-canvas' }}
                backgroundColor="white"
              />
            </div>
            <div className="firma-modal-buttons">
              <button className="btn-secondary" onClick={cancellaPad}>Cancella</button>
              <button className="btn-primary" onClick={confermaFirma}>Conferma</button>
              <button className="btn-danger" onClick={() => setShowFirma(false)}>Annulla</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default CreaBollaForm;